import type { SVGAttributes } from "react";

export const FooterSocialItems = {
	instagram: {
		name: "Instagram",
		baseURL: "https://www.instagram.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
				<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
				<line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
			</svg>
		),
	},
	facebook: {
		name: "Facebook",
		baseURL: "https://www.facebook.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
			</svg>
		),
	},
	x: {
		name: "X (formerly Twitter)",
		baseURL: "https://www.x.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => {
			return (
				<svg
					{...props}
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 300 300"
					fill="none"
					stroke="currentColor"
				>
					<path d="M178.6 127.2 290.3 0h-26.5l-97 110.4L89.3 0H0l117.1 167L0 300.2h26.5l102.4-116.6 81.8 116.6H300M36 19.4h40.7l187 262.2h-40.6" />
				</svg>
			);
		},
	},
	youtube: {
		name: "YouTube",
		baseURL: "https://www.youtube.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
				<polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
			</svg>
		),
	},
	linkedin: {
		name: "LinkedIn",
		baseURL: "https://www.linkedin.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
				<rect x="2" y="9" width="4" height="12" />
				<circle cx="4" cy="4" r="2" />
			</svg>
		),
	},
	tiktok: {
		name: "TikTok",
		baseURL: "https://www.tiktok.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm10-9a3 3 0 0 0-3 3v10a7 7 0 1 1-7-7V7a7 7 0 0 1 7 7h3V3z" />
			</svg>
		),
	},
	email: {
		name: "Email",
		baseURL: "mailto:",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
				<polyline points="22,6 12,13 2,6" />
			</svg>
		),
	},
};

export const FooterPaymentMethods = {
	applepay: {
		name: "Apple Pay",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				fill="none"
				height="20"
				viewBox="0 0 32 32"
				width="20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M0 0h32v32H0z" fill="#F6F8FA"></path>
				<path
					d="M26.672 8H5.328c-.163 0-.327.002-.49.004a3.265 3.265 0 0 0-.49.043 1.56 1.56 0 0 0-1.148.837c-.076.149-.124.3-.153.464a3.442 3.442 0 0 0-.043.49L3 10.06v12.255c0 .164.002.328.004.492.004.163.014.328.043.489a1.562 1.562 0 0 0 .837 1.148c.149.076.3.124.464.153a3.3 3.3 0 0 0 .49.044l.223.003h21.877l.226-.003c.162-.005.326-.015.488-.044a1.65 1.65 0 0 0 .465-.153c.295-.15.534-.389.683-.683.074-.147.126-.304.153-.466.027-.161.041-.324.043-.488.002-.075.003-.149.003-.224l.001-.268V10.062c0-.075-.002-.15-.004-.225a3.243 3.243 0 0 0-.043-.489 1.567 1.567 0 0 0-1.3-1.301 3.274 3.274 0 0 0-.49-.043L26.938 8h-.266Z"
					fill="#000"
				></path>
				<path
					d="M26.672 8.555h.262c.071 0 .143.002.215.004.123.003.27.009.405.034.118.022.217.053.312.103a1.004 1.004 0 0 1 .54.751c.025.134.032.28.035.405l.004.214v12.515c0 .07-.002.141-.004.212 0 .136-.012.272-.034.406a1.08 1.08 0 0 1-.102.311.996.996 0 0 1-.44.44c-.098.05-.202.084-.31.102a2.822 2.822 0 0 1-.404.035 8.19 8.19 0 0 1-.217.002H5.064c-.071 0-.143 0-.212-.002a2.832 2.832 0 0 1-.406-.035 1.087 1.087 0 0 1-.312-.102.995.995 0 0 1-.44-.44 1.09 1.09 0 0 1-.102-.312 2.744 2.744 0 0 1-.033-.405 10.392 10.392 0 0 1-.004-.213V10.066c0-.072.001-.143.004-.215.003-.124.01-.269.034-.405.018-.108.052-.213.102-.31a.998.998 0 0 1 .44-.441 1.11 1.11 0 0 1 .311-.103c.135-.02.27-.032.406-.033l.213-.004h21.607Z"
					fill="#fff"
				></path>
				<path
					d="M10.098 13.599c.223-.28.373-.652.333-1.035-.325.016-.723.214-.953.494-.207.238-.39.628-.342.994.366.032.731-.183.962-.453Zm.33.524c-.531-.032-.984.302-1.237.302-.254 0-.643-.286-1.063-.278a1.567 1.567 0 0 0-1.331.81c-.571.983-.151 2.442.404 3.244.27.396.594.833 1.022.817.405-.016.564-.26 1.055-.26s.634.26 1.062.252c.444-.008.722-.396.991-.793.31-.453.437-.889.444-.913-.007-.007-.857-.333-.864-1.308-.007-.818.666-1.206.699-1.23-.382-.563-.976-.627-1.183-.642m4.626-1.106c1.155 0 1.959.796 1.959 1.955 0 1.162-.82 1.963-1.988 1.963h-1.278v2.032h-.924v-5.95h2.231Zm-1.307 3.143h1.06c.804 0 1.261-.433 1.261-1.184 0-.75-.457-1.18-1.257-1.18h-1.064v2.364Zm3.508 1.574c0-.759.581-1.224 1.612-1.282l1.187-.07v-.334c0-.482-.326-.771-.87-.771-.515 0-.837.247-.915.635h-.84c.049-.784.716-1.362 1.788-1.362 1.052 0 1.724.557 1.724 1.428v2.99h-.853v-.714h-.02c-.252.483-.802.788-1.37.788-.85 0-1.443-.528-1.443-1.308Zm2.8-.39v-.343l-1.069.065c-.53.037-.832.273-.832.644 0 .38.313.627.791.627.623 0 1.11-.428 1.11-.994Zm1.692 3.22v-.722c.066.017.215.017.289.017.413 0 .635-.174.771-.619 0-.009.078-.264.078-.268l-1.566-4.342h.965l1.098 3.53h.016l1.097-3.53h.94l-1.625 4.565c-.37 1.052-.8 1.39-1.699 1.39a3.699 3.699 0 0 1-.363-.021Z"
					fill="#000"
				></path>
			</svg>
		),
	},
	googlepay: {
		name: "Google Pay",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				fill="none"
				height="20"
				viewBox="0 0 32 32"
				width="20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M0 0h32v32H0z" fill="#F5F6F8"></path>
				<path
					d="M15.135 16.453v3.008h-.954v-7.428h2.53c.641 0 1.188.214 1.636.642.457.427.686.95.686 1.566 0 .63-.229 1.153-.686 1.575-.443.423-.99.632-1.636.632h-1.576v.005Zm0-3.505v2.59h1.596c.378 0 .696-.13.944-.383.254-.253.383-.561.383-.91a1.24 1.24 0 0 0-.383-.9 1.238 1.238 0 0 0-.944-.392h-1.596v-.005Zm6.393 1.262c.706 0 1.263.19 1.67.567.408.378.612.895.612 1.551v3.133h-.91v-.706h-.04c-.392.581-.92.87-1.575.87-.562 0-1.03-.165-1.407-.498a1.587 1.587 0 0 1-.567-1.242c0-.527.199-.945.597-1.253.397-.313.93-.468 1.59-.468.567 0 1.034.105 1.397.314v-.22c0-.332-.129-.61-.392-.844a1.347 1.347 0 0 0-.925-.348c-.532 0-.954.223-1.263.676l-.84-.527c.462-.671 1.148-1.004 2.053-1.004Zm-1.233 3.69c0 .248.105.457.318.62.21.165.458.25.741.25.403 0 .76-.15 1.074-.448.313-.298.472-.646.472-1.049-.298-.234-.71-.353-1.242-.353-.388 0-.711.095-.97.278-.263.194-.393.428-.393.701ZM29 14.375l-3.182 7.318h-.984l1.183-2.56-2.098-4.758h1.039l1.511 3.649h.02l1.472-3.65H29Z"
					fill="#3C4043"
				></path>
				<path
					d="M11.339 15.846a5 5 0 0 0-.08-.895h-4v1.64l2.304.001a1.974 1.974 0 0 1-.856 1.321v1.065h1.372c.8-.742 1.26-1.837 1.26-3.132Z"
					fill="#4285F4"
				></path>
				<path
					d="M8.707 17.913c-.381.258-.873.409-1.448.409-1.111 0-2.054-.75-2.392-1.758H3.453v1.097a4.26 4.26 0 0 0 3.806 2.346c1.15 0 2.117-.379 2.82-1.03l-1.372-1.064Z"
					fill="#34A853"
				></path>
				<path
					d="M4.735 15.75c0-.284.047-.558.133-.816v-1.097H3.453A4.236 4.236 0 0 0 3 15.749c0 .688.164 1.338.453 1.913l1.415-1.098a2.568 2.568 0 0 1-.133-.815Z"
					fill="#FABB05"
				></path>
				<path
					d="M7.258 13.177c.628 0 1.19.216 1.634.639l1.216-1.215a4.091 4.091 0 0 0-2.85-1.11 4.26 4.26 0 0 0-3.806 2.346l1.415 1.098c.338-1.01 1.28-1.758 2.391-1.758Z"
					fill="#E94235"
				></path>
			</svg>
		),
	},
	mastercard: {
		name: "Mastercard",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg {...props} height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
				<g fill="none" fillRule="evenodd">
					<path d="M0 0h32v32H0z" fill="#000"></path>
					<g fillRule="nonzero">
						<path d="M13.02 10.505h5.923v10.857H13.02z" fill="#ff5f00"></path>
						<path
							d="M13.396 15.935a6.944 6.944 0 0 1 2.585-5.43c-2.775-2.224-6.76-1.9-9.156.745s-2.395 6.723 0 9.368 6.38 2.969 9.156.744a6.944 6.944 0 0 1-2.585-5.427z"
							fill="#eb001b"
						></path>
						<path
							d="M26.934 15.935c0 2.643-1.48 5.054-3.81 6.21s-5.105.851-7.143-.783a6.955 6.955 0 0 0 2.587-5.428c0-2.118-.954-4.12-2.587-5.429 2.038-1.633 4.81-1.937 7.142-.782s3.811 3.566 3.811 6.21z"
							fill="#f79e1b"
						></path>
					</g>
				</g>
			</svg>
		),
	},
	visa: {
		name: "Visa",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg {...props} height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
				<g fill="none" fillRule="evenodd">
					<path d="M0 0h32v32H0z" fill="#00579f"></path>
					<g fill="#fff" fillRule="nonzero">
						<path d="M13.823 19.876H11.8l1.265-7.736h2.023zm7.334-7.546a5.036 5.036 0 0 0-1.814-.33c-1.998 0-3.405 1.053-3.414 2.56-.016 1.11 1.007 1.728 1.773 2.098.783.379 1.05.626 1.05.963-.009.518-.633.757-1.216.757-.808 0-1.24-.123-1.898-.411l-.267-.124-.283 1.737c.475.213 1.349.403 2.257.411 2.123 0 3.505-1.037 3.521-2.641.008-.881-.532-1.556-1.698-2.107-.708-.354-1.141-.593-1.141-.955.008-.33.366-.667 1.165-.667a3.471 3.471 0 0 1 1.507.297l.183.082zm2.69 4.806.807-2.165c-.008.017.167-.452.266-.74l.142.666s.383 1.852.466 2.239h-1.682zm2.497-4.996h-1.565c-.483 0-.85.14-1.058.642l-3.005 7.094h2.123l.425-1.16h2.597c.059.271.242 1.16.242 1.16h1.873zm-16.234 0-1.982 5.275-.216-1.07c-.366-1.234-1.515-2.575-2.797-3.242l1.815 6.765h2.14l3.18-7.728z"></path>
						<path d="M6.289 12.14H3.033L3 12.297c2.54.641 4.221 2.189 4.912 4.049l-.708-3.556c-.116-.494-.474-.633-.915-.65z"></path>
					</g>
				</g>
			</svg>
		),
	},
	blik: {
		name: "BLIK",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				fill="none"
				height="20"
				viewBox="0 0 32 32"
				width="20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M0 0h32v32H0z" fill="#010101"></path>
				<path
					d="M16.276 13.305a6.268 6.268 0 0 0-2.968.745v-7.1H10v12.629a6.277 6.277 0 0 0 12.553 0 6.275 6.275 0 0 0-6.277-6.274Zm0 9.295a3.021 3.021 0 1 1 0-6.042 3.021 3.021 0 0 1 0 6.042Z"
					fill="#fff"
				></path>
				<path
					d="M19.592 11.921a2.96 2.96 0 1 0 0-5.921 2.96 2.96 0 0 0 0 5.921Z"
					fill="url(#bi_blik__a)"
				></path>
				<defs>
					<linearGradient
						gradientUnits="userSpaceOnUse"
						id="bi_blik__a"
						x1="103.397"
						x2="521.926"
						y1="92.918"
						y2="511.447"
					>
						<stop stopColor="#E52F08"></stop>
						<stop offset="1" stopColor="#E94F96"></stop>
					</linearGradient>
				</defs>
			</svg>
		),
	},
	klarna: {
		name: "Klarna",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				fill="none"
				height="20"
				viewBox="0 0 32 32"
				width="20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M0 0h32v32H0z" fill="#FFA8CD"></path>
				<path
					d="M23.665 6h-4.342c0 3.571-2.185 6.771-5.506 9.057l-1.305.914V6H8v20h4.512v-9.914L19.975 26h5.506l-7.18-9.486c3.264-2.371 5.392-6.057 5.364-10.514Z"
					fill="#0B051D"
				></path>
			</svg>
		),
	},
	przelewy24: {
		name: "Przelewy24",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				fill="none"
				height="20"
				viewBox="0 0 32 33"
				width="20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M0 .097h32v32H0z" fill="#F5F6F8"></path>
				<g clipPath="url(#bi_p24__a)" clipRule="evenodd" fillRule="evenodd">
					<path
						d="m18.28 22.057-.155.818h-6.556l.308-1.616c.172-.905.47-1.498.898-1.78.427-.28 1.355-.496 2.784-.647 1.142-.117 1.85-.276 2.12-.477.273-.202.488-.723.648-1.565.14-.738.102-1.217-.117-1.437-.219-.22-.765-.33-1.641-.33-1.094 0-1.8.09-2.12.268-.322.177-.547.606-.675 1.285l-.11.641h-1.007l.092-.446c.195-1.026.555-1.71 1.08-2.053.526-.34 1.48-.512 2.862-.512 1.227 0 2.017.185 2.369.553.353.37.426 1.088.223 2.157-.195 1.026-.521 1.713-.98 2.058-.46.346-1.359.58-2.698.7-1.176.11-1.894.261-2.153.454-.26.192-.474.739-.645 1.64l-.055.29h5.529Zm8.623-7.747-1.1 5.782h1.362l-.156.818h-1.36l-.377 1.98h-1.025l.376-1.98H19.53l.215-1.137 5.573-5.463h1.587-.001Zm-2.126 5.782.981-5.16h-.02l-5.208 5.16h4.247Z"
						fill="#99A0A6"
					></path>
					<path
						d="M4.656 14.206 3 22.86h1.052l.653-3.41h2.69l.412-.007c1.097 0 1.88-.18 2.346-.54.467-.358.796-1.032.985-2.02.197-1.032.14-1.736-.17-2.112-.31-.376-.992-.564-2.043-.564h-4.27Zm2.699 4.419H4.862l.688-3.595h2.828l.401.007c.743 0 1.191.11 1.347.333.156.222.153.75-.007 1.587-.136.714-.37 1.171-.702 1.37-.331.198-1.02.298-2.062.298Z"
						fill="#D40E2B"
					></path>
					<path
						d="m9.142 11.056-1.012-.67A22.12 22.12 0 0 1 11.847 9l.186.914c-.915.26-1.88.632-2.89 1.142Zm11.481-.502a10.827 10.827 0 0 0-2.992-1l.818-1.457h.023c2.362.01 4.24.308 5.72.721l-3.569 1.737Zm-13.414.302 1.034.7c-.471.27-.953.57-1.443.905H4.793s.83-.738 2.415-1.605Zm10.026-2.709-.484 1.291a12.351 12.351 0 0 0-4.016.264l-.138-.924c1.52-.359 3.074-.57 4.638-.632v.001Zm8.84 1.304c2.14.938 2.925 2.006 2.925 2.006h-6.92s-.228-.197-.659-.472l4.654-1.534Z"
						fill="#99A0A6"
					></path>
				</g>
				<defs>
					<clipPath id="bi_p24__a">
						<path d="M0 0h26v14.793H0z" fill="#fff" transform="translate(3 8.097)"></path>
					</clipPath>
				</defs>
			</svg>
		),
	},
};

export type FooterSocialKey = keyof typeof FooterSocialItems;
export type FooterPaymentMethodKey = keyof typeof FooterPaymentMethods;
